"use strict";function isEnableGPUAcceleration$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.isEnableGPUAcceleration$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.util.isEnableGPUAcceleration";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.pc]={vs:"6.0.22"},_a)),exports.isEnableGPUAcceleration$=isEnableGPUAcceleration$,exports.default=isEnableGPUAcceleration$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/util/isEnableGPUAcceleration.js
// module id = 1010
// module chunks = 106